import React, {useState} from 'react';
import { Button, Loader } from 'library';

const LoadMore = ({ onClick }) => {
  const [loading, setLoading] = useState(false);
  const handleClick = () => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
      onClick()
    }, 500)
  }

  return (
    <Button theme="link" onClick={handleClick}>
      {loading ? <Loader /> : "LOAD MORE"}
    </Button>
  );
};

export default LoadMore;
